<div class="ppl-container-body">
    <div class="ppl-container-head">
        Billing Claim Adjustment
    </div>
    <div class="ppl-container">
        <div class="ppl-content-container"
            style="padding: 8px; max-height: calc(100vh - 140px); box-sizing: border-box;">

            <div style="width: 100%; box-sizing: border-box;">
                <div class="ppl-tabs">
                    <div class="ppl-nav ppl-nav-tabs collapse d-md-flex">
                        <div *ngFor="let section of sections;" class="ppl-nav-item">
                            <a class="ppl-nav-link" (click)="onSectionSelection(section)"
                                [class.active]="section === selectedSection" href="javascript:void(0)">
                                {{ section }}
                            </a>
                        </div>
                    </div>
                    <div class="tab-content">
                        @if(!showBulkAdjustment) {
                        <ppl-claim-adjustment></ppl-claim-adjustment>

                        } @else {
                        <ppl-bulk-claim-adjustment></ppl-bulk-claim-adjustment>
                        }
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>